module.exports = __webpack_public_path__ + "static/media/new_logo.7bd8d16a.png";